/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { getWithdrawals } from "./../../helpers/withdraw";
import { useSelector, useDispatch } from "react-redux";
import {
  Typography,
  Avatar,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Table,
  Skeleton,
  Box,
  Chip,
  Button,
} from "@mui/material";
import { ToggleDepositModal } from "./../../store/actions/app.js";
import moment from "moment";

const Withdrawals = () => {
  // state
  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);

  // redux
  const { token } = useSelector((state) => state.app);
  const dispatch = useDispatch();

  // lifecycles
  useEffect(() => {
    handleGetWithdrawals();
  }, []);

  // methods
  const handleGetWithdrawals = async () => {
    try {
      const [, response] = await getWithdrawals(token);
      setList(response.data);
      setLoading(false);
    } catch(err) {
      setLoading(false);
    }
  };

  return (
    <div className="row">
      <div className="col-12">
        <div className="d-flex align-items-center mb-3 justify-content-between">
          <Typography variant="h6" fontWeight={700}>
            Withdrawals
          </Typography>
          <Button 
            size="small" 
            variant="contained" 
            className="ms-3"
            onClick={() => {
              dispatch(ToggleDepositModal(true, 1));
            }}
            >Withdraw
          </Button>
        </div>
        <TableContainer component={Paper}>
          <Table size="small" sx={{ minWidth: 650 }} aria-label="Assets Table">
            <TableHead>
              <TableRow>
                <TableCell>Asset</TableCell>
                <TableCell align="left">Amount</TableCell>
                <TableCell align="left">Status</TableCell>
                <TableCell align="right">Date</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading && (
                <TableRow>
                  <TableCell colSpan="4">
                    <Skeleton/>
                    <Skeleton/>
                    <Skeleton/>
                  </TableCell>
                </TableRow>
              )}
              {!loading && list.length === 0 && (
                <TableRow>
                  <TableCell className="text-center" sx={{ border: 0 }} colSpan={4}>
                    <Typography my={2} variant="body2">You don't have any withdrawal requests yet.</Typography>
                  </TableCell>
                </TableRow>
              )}
              {!loading && list.length > 0 && (
                <>
                  {list.map((item, i) => (
                    <TableRow
                      hover={true}
                      key={i}
                      sx={{ 
                        '&:last-child td, &:last-child th': { border: 0 },
                      }}
                    >
                      <TableCell
                        component="th"
                        scope="row"
                        className="d-flex align-items-center"
                      >
                        <Avatar
                          className="me-3"
                          alt={`${item.name}'s Logo`}
                          src={item.asset.logo.url}
                        />
                        <Box>
                          <Typography variant="body2">
                            {item.asset.name}
                          </Typography>
                          <Typography variant="caption" className="d-block">
                            {item.asset.display_symbol}
                          </Typography>
                        </Box>
                      </TableCell>
                      <TableCell align="left">
                        <strong>
                          {item.amount.toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                          })}
                        </strong>
                      </TableCell>
                      <TableCell align="left">
                        <Chip
                          label={item.status}
                          size="small"
                          sx={{ bgcolor: "#f39c12", borderRadius: 1 }}
                        />
                      </TableCell>
                      <TableCell align="right">
                        {moment(item.createdAt).format(
                          "MMM D YYYY, h:mm:ss a"
                        )}
                      </TableCell>
                    </TableRow>
                  ))}
                </>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  )
};
export default Withdrawals;
